import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { FacilityBillableRateDto } from '../models';

export const MOCK_BILLABLE_RATES: FacilityBillableRateDto[] = [
  {
    id: '550e8400-e29b-41d4-a716-446655440000',
    createdAt: '2026-01-13T09:00:00Z',
    updatedAt: '2026-01-13T09:00:00Z',
    facilityId: 'f1a2b3c4-d5e6-7890-abcd-111111111111',
    facilityName: 'Sunrise Medical Center',
    scopeOfPractice: ScopeOfPracticeEnum.Rn,
    scopeOfPracticeDisplay: 'Registered Nurse',
    hourlyRate: 45,
    scheduledRates: [
      {
        id: 'a1b2c3d4-e001-42aa-bbbb-222222222222',
        rate: 50,
        effectiveFrom: '2026-02-01',
        effectiveTo: '2026-06-01'
      }
    ],
    differentialRate: 8,
    isDifferentialModified: false,
    totalRate: 53,
    isBaseRateOverridden: false,
    isActive: true
  },
  {
    id: '660e8400-e29b-41d4-a716-446655440000',
    createdAt: '2026-01-13T09:10:00Z',
    updatedAt: '2026-01-13T09:10:00Z',
    facilityId: 'abcd1234-d5e6-7890-abcd-333333333333',
    facilityName: 'Green Valley Clinic',
    scopeOfPractice: ScopeOfPracticeEnum.Cna,
    scopeOfPracticeDisplay: 'Certified Nursing Assistant',
    hourlyRate: 22,
    scheduledRates: [
      {
        id: 'b2c3d4e5-e002-43bb-cccc-444444444444',
        rate: 25,
        effectiveFrom: '2026-03-01',
        effectiveTo: '2026-08-01'
      }
    ],
    differentialRate: 8,
    isDifferentialModified: false,
    totalRate: 30,
    isBaseRateOverridden: false,
    isActive: true
  },
  {
    id: '770e8400-e29b-41d4-a716-446655440000',
    createdAt: '2026-01-13T09:20:00Z',
    updatedAt: '2026-01-13T09:20:00Z',
    facilityId: '99991234-d5e6-7890-abcd-555555555555',
    facilityName: 'Oceanview Hospital',
    scopeOfPractice: ScopeOfPracticeEnum.Pt,
    scopeOfPracticeDisplay: 'Physical Therapist',
    hourlyRate: 60,
    scheduledRates: [
      {
        id: 'c3d4e5f6-e003-44cc-dddd-666666666666',
        rate: 65,
        effectiveFrom: '2026-01-15',
        effectiveTo: '2026-12-31'
      }
    ],
    differentialRate: 8,
    isDifferentialModified: false,
    totalRate: 68,
    isBaseRateOverridden: false,
    isActive: false
  }
];
